import type { FilterPreset } from '@ipfabric/utils';
import type { ApiTableCommandFactory } from 'components/ApiTable/model/ApiTableModel';
import { initializeSimpleFilters } from 'components/ApiTable/model/commands/initializeSimpleFilters';
import { reloadTableData } from 'components/ApiTable/model/commands/reloadTableData';
import { setFilters } from 'components/ApiTable/model/commands/setFilters';

export interface SelectFilterPresetCommand {
  preset: FilterPreset | null;
}

export const selectFilterPreset: ApiTableCommandFactory<
  SelectFilterPresetCommand
> = (cmdContext, dispatch) => async (command) => {
  // We don't want to clean up simple filters when preset is cleared
  // because it could be reset because simple filter was added.
  // If we would reset simple filters in that case, then simple filter would be lost
  if (command.preset !== null) {
    // clean up simple filters UI
    dispatch(initializeSimpleFilters, { initialFilters: {} });
  }

  cmdContext.updateState((draft) => {
    draft.selectedFilterPreset = command.preset;
  });
  dispatch(setFilters, {
    filters: command.preset?.filter ?? {},
    origin: command.preset ? 'preset' : 'empty',
  });

  dispatch(reloadTableData);
};
